<template>
  <div>
    <d-container fluid class="main-content-container px-4" v-if="feature">
      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Facilities</span>
          <h3 class="page-title">{{feature.localizedTitle}}</h3>
        </div>
      </div>

      <d-row>
        <d-col lg="12">
          <d-card class="card-small">
            <d-card-body>
              <d-row>
                <d-col lg="6">
                  <d-alert theme="danger" show v-if="submitted && (!success && !errors.length)">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span>An unexpected error occurred.</span>
                  </d-alert>

                  <d-alert theme="success" show v-if="submitted && success">
                    <span>Your changes have been saved.</span>
                  </d-alert>

                  <d-row class="mb-2">
                    <d-col lg="3" style="display: flex; align-items: center;"><strong>Category</strong></d-col>
                    <d-col>
                      <d-select v-model="feature.category" :class="{ 'is-invalid': hasError('category') }">
                        <option value="safety">Safety</option>
                        <option value="facility">Facility</option>
                        <option value="service">Service</option>
                        <option value="special">Special</option>
                      </d-select>
                      <span class="invalid-feedback" v-if="hasError('category')">{{ getError('category') }}</span>
                    </d-col>
                  </d-row>

                  <d-row class="mb-2">
                    <d-col lg="3" style="display: flex; align-items: center;"><strong>Title</strong></d-col>
                    <d-col>
                      <v-multi-language v-model="feature.title" :class="{ 'is-invalid': hasError('title') }" />
                      <span class="invalid-feedback" v-if="hasError('title')">{{ getError('title') }}</span>
                    </d-col>
                  </d-row>

                  <d-row class="mb-2">
                    <d-col lg="3" style="display: flex; align-items: center;"><strong>Remark</strong></d-col>
                    <d-col>
                      <v-multi-language textarea v-model="feature.remark" :class="{ 'is-invalid': hasError('remark') }" />
                      <span class="invalid-feedback" v-if="hasError('remark')">{{ getError('remark') }}</span>
                    </d-col>
                  </d-row>

                  <d-button theme="primary" @click="onSubmit" :disabled="submitted">Save Changes</d-button>
                </d-col>
              </d-row>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
export default {
  methods: {
    hasError: function (field) {
      return this.errors.find(error => error.field === field);
    },

    getError: function (field) {
      return this.errors.find(error => error.field === field).message;
    },

    getIconUrl: function (fileName) {
      return process.env.VUE_APP_CDN_URL + fileName;
    },

    onIconUpload: function (event) {
      if (event.target.files.length > 0) {
        this.fields.icon = {
          fileName: event.target.files[0].name,
          file: event.target.files[0],
        };
      }
    },

    onSubmit: async function (event) {
      event.preventDefault();

      const remark = [];
      const title = [];

      Object.entries(this.feature.title).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        title.push({
          language: language,
          text: text,
        });
      });

      Object.entries(this.feature.remark).forEach(([language, text]) => {
        if (!text.length) {
          return;
        }

        remark.push({
          language: language,
          text: text,
        });
      });

      this.submitting = true;
      this.submitted = false;
      this.errors = [];

      const data = await this.$apollo.mutate({
        mutation: require('../../graphql/UpdateFeature.gql'),
        variables: {
          id: this.feature.id,
          icon: this.fields.icon.file,
          title: title,
          remark: remark,
          category: this.feature.category,
        },
      });

      this.submitting = false;
      this.submitted = true;
      this.success = data.data.updateFeature.success;

      if (!this.success) {
        this.errors = data.data.updateFeature.errors;
      } else {
        window.location.reload(true);
      }
    },
  },
  apollo: {
    load: function () {
      return {
        fetchPolicy: 'no-cache',
        variables: {
          id: this.$route.params.id,
        },
        update: function (data) {
          this.feature = data.feature;
        },
        query: require('../../graphql/GetSingleFeature.gql'),
      };
    },
  },
  data: function () {
    return {
      submitting: false,
      submitted: false,
      feature: undefined,
      success: false,
      errors: [],
      fields: {
        icon: {
          fileName: '',
          file: undefined,
        },
      },
    };
  },
};
</script>
